import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { Link } from 'react-router-dom';
import SolidButton from '@/components/Button/SolidButton';
import Loader from '@/components/Loader';
import useNetwork from '@/hooks/useNetwork';
import useRouter from '@/hooks/useRouter';
import BubbleLayout from '../BubbleLayout';
import Urls from '../Urls';

export default function Layout() {
  const { history, match } = useRouter();

  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  const network = useNetwork();

  if (project.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  const isEligibleForGrants = network?.data?.grants === 'Yes';

  let backLink = Urls(project).RESOURCES;
  if (isEligibleForGrants) {
    backLink = project.data.grant === 'Yes'
      ? Urls(project).BUDGET
      : Urls(project).GRANT;
  }

  return (
    <BubbleLayout
      project={project}
      page="Search Explanation"
    >
      <div className="px-10 pt-32 pb-32 max-w-screen-lg m-auto">
        <div className="text-3xl text-cs-gray-900 font-semibold text-center mb-4">
          Congratulations! You&apos;ve shared your idea with the world.
        </div>
        <div className="text-base text-cs-gray-700 text-center space-y-2 mb-12">
          <div>
            On the next screen, we&apos;ll show you some partners who might be a good fit for your project or event.
          </div>
          <div>
            It&apos;s a great idea to take a few minutes now to invite at least a couple of them to start a conversation.
          </div>
          <div>
            You&apos;re not alone! CommunityShare and your local steward will begin promoting your idea to potential partners.
          </div>
        </div>
        <div className="flex flex-col items-center space-y-6 text-right">
          <SolidButton onClick={() => history.push(Urls(project).PROJECT_INVITE)}>
            Next
          </SolidButton>
          <Link className="text-lg text-cs-orange-500 font-semibold" to={backLink}>
            Back
          </Link>
        </div>
      </div>
    </BubbleLayout>
  );
};
